/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';

export type SomniaInternalTrxInfo = {
    BNO: string;
    AG: string;
    PTRXHA: string;
    STP: SomniaInternalTrxInfo.STP;
    TMT: SomniaInternalTrxInfo.TMT;
    ADDRSFROMINFO: EvmAddressSummaryInfo;
    ADDRSTOINFO: EvmAddressSummaryInfo;
    AMT: string;
    VA: string;
    UT: number;
};

export namespace SomniaInternalTrxInfo {

    export enum STP {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }

    export enum TMT {
        CALL = 'CALL',
        CREATE = 'CREATE',
        CREATE2 = 'CREATE2',
        STATICCALL = 'STATICCALL',
        SELFDESTRUCT = 'SELFDESTRUCT',
        DELEGATECALL = 'DELEGATECALL',
        CALLCODE = 'CALLCODE',
    }


}

